"use client";
import { ChevronDown, ChevronUp } from "lucide-react";
import { ReactNode } from "react";

interface AccordionWithCheckboxProps {
  title: string;
  index: number;
  isOpen?: boolean;
  onClick: (index: number) => void;
  icon?: ReactNode;
  className?: string;
  classNameHead?: string;
  classNameBody?: string;
  children: ReactNode;
  rightComponent?: ReactNode;
  viewChevron?: boolean;
}

const Accordion: React.FC<AccordionWithCheckboxProps> = ({
  title,
  index,
  isOpen,
  onClick,
  icon,
  className="",
  classNameHead="",
  classNameBody="",
  children,
  rightComponent,
  viewChevron=true,
}) => {
  return (
    <div
      
      className={` ${className}`}
    >
      <div
        className={`w-full flex justify-between items-center text-sm font-medium text-gray-700 transition-all ${classNameHead}`}
      >
        <button
          type="button"
          className="flex-1 flex items-center text-left"
          onClick={() => onClick(index)}
        >
          {icon && <span className="mr-2">{icon}</span>}
          <span className="font-semibold">{title}</span>
        </button>

        {rightComponent && <div className="ml-2">{rightComponent}</div>}
        {viewChevron&&(
            <button type="button" className="ml-3" onClick={() => onClick(index)}>
                {isOpen ? (
                    <ChevronUp className="w-5 h-5" />
                ) : (
                    <ChevronDown className="w-5 h-5" />
                )}
            </button> 
        )}
        

      </div>

      <div 
        className={` transition-all duration-300 ${classNameBody} ${
          isOpen
            ? "animate-fade-in"
            : "h-0 max-h-0 opacity-0 overflow-hidden"
        }`}
      >
        {children}
      </div>
    </div>
  );
};

export default Accordion;
